import {useParams} from "react-router-dom";

export default function useLocale(): string {
    const {locale} = useParams<{ locale?: string }>();
    return locale ?? 'de';
}